import * as Tutorial from './tutorial'
import * as TutorialRole from './tutorial-role'

export const queries = [Tutorial.Query, TutorialRole.Query]

export const mutations = [Tutorial.Mutation, TutorialRole.Mutation]
